// todo: use numeral formatting instead of this functions

export const convertByteToGB = (data: number): number => {
  return data / (1000 * 1000 * 1000);
};

export const convertGBToByte = (data: number): number => {
  return data * 1_000_000_000;
};
